































import Vue from 'vue'
import SimpleModalLayout from '@/components/modal/basics/SimpleModal/SimpleModalLayout.vue'
import SimpleModalFooterButton from '@/components/modal/basics//SimpleModal/SimpleModalFooterButton.vue'

export default Vue.extend({
  components: {
    SimpleModalLayout,
    SimpleModalFooterButton,
  },
  computed: {
    isPasswordChangePage(): boolean {
      return this.$route.path === '/help/password_recovery'
    },
  },
  created() {
    this.$modal.push('PasswordChangeWarningModal')
  },
  methods: {
    handleChangePassword() {
      this.$modal.pop()
      if (!this.isPasswordChangePage) {
        this.$router.push('/help/password_recovery')
      }
    },
  },
})
